import min from './min'
import max from './max'
import normalize from './normalize'

export default ({ value, width }) =>
  ((normalize(value) - min) / (max - min)) * width
